/**
 * Maps viewport (client) coordinates to canvas backing-store pixels when the element is displayed
 * with `object-fit: contain` (uniform scale + letterboxing). The naive
 * `(client - rect.left) * (canvas.width / rect.width)` mapping is wrong whenever aspect ratios differ.
 */
export function clientToCanvasBitmapPoint(
  clientX: number,
  clientY: number,
  canvas: HTMLCanvasElement
): { x: number; y: number } | null {
  const rect = canvas.getBoundingClientRect();
  const cw = canvas.width;
  const ch = canvas.height;
  if (cw <= 0 || ch <= 0 || rect.width <= 0 || rect.height <= 0) return null;

  const scale = Math.min(rect.width / cw, rect.height / ch);
  const displayW = cw * scale;
  const displayH = ch * scale;
  const offsetX = rect.left + (rect.width - displayW) / 2;
  const offsetY = rect.top + (rect.height - displayH) / 2;
  const x = (clientX - offsetX) / scale;
  const y = (clientY - offsetY) / scale;
  if (x < -0.5 || x > cw + 0.5 || y < -0.5 || y > ch + 0.5) return null;
  return { x, y };
}
